export interface ReportDoneFilters {
  startDate: string;
  endDate: string;
  locationIds?: number[];
  departmentIds?: number[];
  areaIds?: number[];
  zones?: string[];
  typeAudit?: string | null;
  auditorIds?: number[];
  coAuditorIds?: number[];
}

export interface ReportDoneZone {
  zone: string;
  plan: number;
  fact: number;
}

export interface ReportDoneArea {
  areaId: number;
  areaName: string;
  plan: number;
  fact: number;
  cross: { plan: number; fact: number } | null;
  zones: ReportDoneZone[];
}

export interface ReportDoneDepartment {
  departmentId: number;
  departmentName: string;
  plan: number;
  fact: number;
  areas: ReportDoneArea[];
}

export interface ReportDoneLocation {
  locationId: number;
  locationName: string;
  plan: number;
  fact: number;
  departments: ReportDoneDepartment[];
}

export interface ReportDoneMonth {
  year: number;
  monthIdx: number;
  monthName: string;
  locations: ReportDoneLocation[];
}

export interface ReportDonePercentColor {
  from: number;
  to: number;
  color: string;
  label: string | null;
}

export interface ReportDoneData {
  months: ReportDoneMonth[];
  percentColors: ReportDonePercentColor[];
}

export interface ReportDone5SAuditState {
  data: ReportDoneData | null;
  loading: boolean;
  error: string | null;
}

export enum ReportDone5SAuditActionTypes {
  LOAD_REQUEST = 'reportDone5SAudit/LOAD_REQUEST',
  LOAD_SUCCESS = 'reportDone5SAudit/LOAD_SUCCESS',
  LOAD_FAILURE = 'reportDone5SAudit/LOAD_FAILURE',
}

export interface LoadRequestAction {
  type: ReportDone5SAuditActionTypes.LOAD_REQUEST;
  payload: { filters: ReportDoneFilters };
}

export interface LoadSuccessAction {
  type: ReportDone5SAuditActionTypes.LOAD_SUCCESS;
  payload: { data: ReportDoneData };
}

export interface LoadFailureAction {
  type: ReportDone5SAuditActionTypes.LOAD_FAILURE;
  payload: { error: string };
}

export type ReportDone5SAuditActions = LoadRequestAction | LoadSuccessAction | LoadFailureAction;
